import {
  Component,
  HostListener,
  inject,
  OnInit,
  Renderer2,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '@env/environment';
import { IconeComponent } from './ui/icone/icone.component';
import { NotificationService } from './ui/notification/notification.service';
import { installerInfobulles } from './ui/infobulle/infobulles-globales';
import { NavigationEtatComponent } from './layout/navigation-etat/navigation-etat.component';
import { Deconnexion } from './core/session';
import { TelemetrieService } from './core/telemetrie/telemetrie.service';

/**
 * Racine de l'application : routeur, écran de chargement / d'erreur des navigations (app-navigation-etat) et
 * message bref (toast) commun à tous les écrans. Installe aussi les comportements globaux : Entrée passe au champ
 * suivant dans les fenêtres et formulaires, infobulles au style de la maquette, menu contextuel du navigateur
 * désactivé en production (sauf sur les liens), comme l'ancien front.
 */
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, IconeComponent, NavigationEtatComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  readonly toast = inject(NotificationService);
  private readonly renderer = inject(Renderer2);
  /** Démarrée dès le lancement : suit la déconnexion faite dans un autre onglet (core/session.ts). */
  private readonly deconnexion = inject(Deconnexion);

  constructor() {
    // Collaborateur : temps passé par dossier et par activité, comme le bureau (core/telemetrie).
    if (LOGAIA_COLLAB_BUILD) {
      inject(TelemetrieService).demarrer();
    }
  }

  /**
   * Règle générale des formulaires : Entrée fait passer au champ texte suivant
   * (fenêtres .modal et formulaires .form). Un champ qui utilise Entrée pour autre chose
   * (recherche SIRET, recherche de compte…) appelle preventDefault et n'est pas concerné.
   */
  @HostListener('document:keydown.enter', ['$event'])
  onEnterNext(event: Event): void {
    const el = event.target as HTMLElement;
    if (event.defaultPrevented || !(el instanceof HTMLInputElement)) {
      return;
    }
    if (['checkbox', 'radio', 'file', 'button', 'submit'].includes(el.type)) {
      return;
    }
    const zone = el.closest('.modal, .form');
    if (!zone) {
      return;
    }
    const champs = Array.from(
      zone.querySelectorAll<HTMLElement>(
        'input:not([type=checkbox]):not([type=radio]):not([type=hidden]):not([type=file]):not([disabled]):not([readonly]), textarea:not([disabled]), [contenteditable=true]',
      ),
    ).filter((c) => c.offsetParent !== null);
    const index = champs.indexOf(el);
    if (index < 0) {
      // Champ hors de la liste (ex. recherche d'une liste flottante) : comportement natif.
      return;
    }
    const suivant = champs[index + 1];
    if (suivant) {
      event.preventDefault();
      suivant.focus();
    }
  }

  ngOnInit(): void {
    // Infobulles au style de la maquette pour tous les attributs title.
    installerInfobulles();

    if (environment.prod) {
      this.renderer.listen('document', 'contextmenu', (evt: PointerEvent) => {
        if ((evt.target as HTMLElement).tagName.toLowerCase() !== 'a') {
          evt.preventDefault();
        }
      });
    }
  }
}
